
import React from 'react';

const SpecializationSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Industrial Large-Scale Projects
          </h2>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-8 items-start">
          <div className="lg:col-span-1">
            <div className="bg-gray-50 p-8 rounded-lg">
              <p className="text-gray-700 leading-relaxed">
                We specialize in safety staffing solutions for industrial large-scale infrastructure projects. Bridge construction projects require safety professionals with specialized knowledge of working over water, heavy equipment operations, structural steel placement, and concrete pouring at significant heights.
              </p>
              <br />
              <p className="text-gray-700 leading-relaxed">
                Highway construction projects demand safety expertise in traffic control, excavation safety, asphalt operations, and coordination with live traffic conditions. Our professionals understand the unique challenges of these large-scale operations and ensure compliance with all federal and state safety regulations.
              </p>
            </div>
          </div>
          
          <div className="lg:col-span-2">
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/09f10015f0b74874992ac7dc4dc7bbd2.jpg" 
                alt="Safety staffing for large-scale bridge and highway construction projects"
                className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
        
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-blue-50 p-6 rounded-lg text-center">
            <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-road-map-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Bridge Construction</h3>
            <p className="text-gray-600 text-sm">Specialized safety for over-water operations and structural steel work</p>
          </div>
          
          <div className="bg-orange-50 p-6 rounded-lg text-center">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-roadster-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Highway Construction</h3>
            <p className="text-gray-600 text-sm">Traffic control safety and live traffic coordination expertise</p>
          </div>
          
          <div className="bg-green-50 p-6 rounded-lg text-center">
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-truck-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Heavy Equipment Operations</h3>
            <p className="text-gray-600 text-sm">Advanced safety protocols for crane and machinery operations</p>
          </div>
          
          <div className="bg-purple-50 p-6 rounded-lg text-center">
            <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-building-2-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Infrastructure Development</h3>
            <p className="text-gray-600 text-sm">Comprehensive safety management for large-scale projects</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecializationSection;
